type IconComponentProps = {
  className?: string;
  onClick?: (val: any) => void;
  style?: any;
  children?: string;
  dataFeather?: string;
  title?: string;
};

const IconComponent = ({
  className,
  onClick,
  style,
  children,
  title
}: IconComponentProps) => {
  return (
    <i className={className} onClick={onClick} style={style} title={title}>
      {children}
    </i>
  );
};

export default IconComponent;
